import { BusinessSummaryData } from '../../../models/fixed/data-analysis';

// 格式化每日营业汇总 未税总额
export const formatTotalWithoutTax = (item: BusinessSummaryData) => {
    // 旧版本未税总额
    const oldValue = Number(Number(item?.total_actual_amount) - Number(item?.total_tax_amount));
    // 新版本未税总额
    const newValue = Number(item?.total_without_tax);
    // type 未税总额版本 1 新版本 2旧版本
    return item.type === '1' ? newValue : oldValue;
};
// 格式化每日营业汇总 应税总额
export const formatTotalTax = (item: BusinessSummaryData) => {
    // 旧版本应税总额
    const oldValue = Number(item?.total_tax_amount);
    // 新版本应税总额
    const newValue = Number(item?.total_tax_fee);
    // type 未税总额版本 1 新版本 2旧版本
    return item.type === '1' ? newValue : oldValue;
};